import React from "react";
import Modal, { ModalTransition } from "@atlaskit/modal-dialog";
import apiClient from "../../api/admin-api-client";
import { toast } from "react-toastify";
import useAsync from "../../hooks/use-async";
import { useTranslation } from "react-i18next";

export default function RemoveWorkflowFromDocumentType({ documentTypeId, workflow, onRemoved, onClose }) {
    const { run, isPending } = useAsync();
    const { t } = useTranslation();
    const remove = () => {
        run(apiClient(`document-type/${documentTypeId}/workflow/${workflow?.id}`, { method: "DELETE"}))
            .then(() => {
                toast.success(t("admin_remove_workflow_from_document_success"));
                onRemoved && onRemoved();
            })
            .catch(error => toast.error(t("admin_remove_workflow_from_document_error") +  error.message));
    };

    return (
        <>
            <ModalTransition>
                <Modal
                    isLoading={isPending}
                    actions={[
                        { text: t("admin_remove_workflow_from_document_remove"), onClick: remove, isLoading: isPending },
                        { text: t("admin_remove_workflow_from_document_cancel"), onClick: onClose, isDisabled: isPending },
                    ]}
                    onClose={close}
                    heading={t("admin_remove_workflow_from_document_heading")}
                    appearance="danger"
                >
                    <p>
                        {t("admin_remove_workflow_from_document_heading_p")}
                    </p>
                </Modal>
            </ModalTransition>
        </>
    );
}